import React from 'react'
import DocSearchFavouriteRow from './DocSearchFavouriteRow'
import SarasMenu from '../../../../library/repeater/menu/SarasMenu'
import { Icon } from '../../../../library/decor/SarasIcons';
import SarasTooltip from '../../../../library/notifications/SarasTooltip';

const DocSearchFavourite = (props) => {
    const { viewData, onFavSelected, tooltip, tooltipAlign } = props;

    // console.log('favorites data', viewData)

    const renderFavMenu = () => {
        let DropdownIcon = Icon['arrowmenu'];

        return (
            <SarasTooltip tooltipAlign={tooltipAlign} title={tooltip ? tooltip : ""}>
                <span className='uiFlexBox3 uiLink'>
                    <DropdownIcon className='uiBrandColor1'/>
                </span>
            </SarasTooltip>
        )
      }
  
    if(!viewData)
        return(null)  

    return (
        <SarasMenu menuTrigger={renderFavMenu()} 
        dataList={Object.values(viewData)} 
        menuItem={DocSearchFavouriteRow} onSelection={onFavSelected}></SarasMenu>
)
}

export default DocSearchFavourite